<template>
  	<div>
  		<ws-loading></ws-loading>
    	<ws-alert></ws-alert>

   		<component :is="layout || 'section'">
      		<router-view />
    	</component>
  	</div>
</template>

<script setup>
	// Imports
	import { computed } from "vue"

	import { useRouter } from "vue-router"
	import { useStore } from 'vuex'

	// Hooks
	const router = useRouter()
	const store = useStore()

	// Computed
	const loading = computed(() => store.getters.getLoading)
	const layout = computed(() => router.currentRoute.value.meta.layout)

</script>


<style lang="scss">
    * {
        scrollbar-color:  #2A388F transparent;
        scrollbar-width: thin;
    }

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
        
        
	}

	nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	input[type="number"] {
		-moz-appearance: textfield;
		appearance: textfield;
		margin: 0;
	}
</style>
